var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VisitList',{attrs:{"title":"ویزیت‌های تأییدشده","status":"3","detail-route":"answerListCustomers"}})
}
var staticRenderFns = []

export { render, staticRenderFns }